export default __webpack_public_path__ + "static/media/sl.3ed89bd3.svg";